import { clientApiCall } from "./apiCallWrapper";

/**
 * Клиентский (браузерный) API каталожных разделов.
 * Ходит только в свой же Next.js BFF (pages/api/client/sections/*), который уже
 * проксирует запрос в Bitrix bxApi с кэшем в Redis.
 *
 * Запросы ботов/краулеров (Bytespider ~61% событий 503, Baiduspider, ClaudeBot)
 * отсекаются через `skipForRobots` — они дёргали getSections на каждой странице
 * и флудили бэкенд.
 */
export default (_axios: any, config: any) => ({
  getSections(reset = false) {
    return clientApiCall(
      `${config.API_SERVER_URL}/client/sections/getSections/`,
      {
        api: "sections.getSections",
        params: { reset },
        skipForRobots: true,
      },
    );
  },
});
